export default __webpack_public_path__ + "static/media/Major Rune Stone of the Judgment Bolt.f5a476ed.jpg";